"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsDetailedModel = void 0;
const getIsDetailedModel = (state) => {
    if (state) {
        return (state.selectedModelIndex >= 0 &&
            state.models[state.selectedModelIndex].isDetailed);
    }
};
exports.getIsDetailedModel = getIsDetailedModel;
